import { render, staticRenderFns } from "./blog15.vue?vue&type=template&id=56fdf131"
import script from "./blog15.vue?vue&type=script&lang=js"
export * from "./blog15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports